// Fixed full-viewport gradient field + drifting starfield. The app's backdrop —
// rendered once, never blurred (glass surfaces blur on top of it). The visual
// treatment lives in the .ambient* classes in index.css.
type Props = { variant?: 'full' | 'subtle' };

export function AmbientBackground({ variant = 'subtle' }: Props) {
  return (
    <div aria-hidden="true" className={variant === 'subtle' ? 'ambient ambient--subtle' : 'ambient'}>
      <div className="ambient__stars" />
    </div>
  );
}
